export interface AkaStudentProductIntroFormValues {
  country: string;
  region: CountryCode;
}

export enum CountryCode {
  NO = "NO",
  NOR = "NOR",
  EU = "EU",
  AUS = "AUS",
  USA = "USA",
  OTHER = "OTHER",
}
